// HourglassLoader.js
import React from "react";
import "./HourglassLoader.css";

const HourglassLoader = () => {
  return (
    <div className="hourglass-loader-container">
      <div className="hourglass"></div>
    </div>
  );
};

export default HourglassLoader;
